import React from "react";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Redirect, Route } from "react-router-dom";

function PrivateRoute({ children, ...rest }) {
	const { user } = useContext(AuthContext);
	return (
		<Route {...rest} render={({ location }) => {
			return user ? children : <Redirect to={{
				pathname: '/',
				state: { from: location }
			}} />
		}} />
	);
}

export default PrivateRoute;
